const forge = require('node-forge')
const pki = forge.pki

class RsaEncriptar {

    /**
     * Método que permite encriptar los datos de inicio de sesión
     * @param  objectData datos del usuario para iniciar sesion
     * @param  publicKeyString clave pública para encriptar información
     * @returns string encriptado
     */
    encriptar(objectData, publicKeyString){
      
      const pem = `-----BEGIN PUBLIC KEY-----\n${publicKeyString}\n-----END PUBLIC KEY-----`;

        const publicKey = pki.publicKeyFromPem(pem)

        const jsonString= JSON.stringify(objectData)

        // encriptar jsonString
        const encrypted = publicKey.encrypt(jsonString, 'RSA-OAEP', {
            md: forge.md.sha256.create(),
            mgf1: {
              md: forge.md.sha1.create()
            }
          });

        return forge.util.encode64(encrypted)
    }
}

export default new RsaEncriptar
